/**
 * 组件库的最小公共形状。
 *
 * 单独一个文件是为了**打断循环依赖**：每个控件都要 `Widget`，
 * 而桶（`widgets.ts`）又要 re-export 每个控件。
 */

import { Container } from 'pixi.js';

/**
 * 一个控件。
 *
 * ⚠️ **`height` 必须等于它真正占据的高度。** 这条踩过一次：
 * `toggle` 的说明文字画在下面，而 `height` 只报了那一行的高 ——
 * 于是竖排版面的游标按 `height` 往前走，下一个控件正好压在说明上。
 * 症状是一片叠字，看起来像渲染错乱，其实是"控件少报了自己的高度"。
 */
export interface Widget {
  readonly container: Container;
  readonly width: number;
  readonly height: number;
}

/** 能竖着摆进版面的东西：控件，或者一个裸容器（`label()` 返回的就是 `Text`） */
export type Placeable = Widget | Container;

/** 统一销毁：控件都是"一个容器 + 一堆孩子"，一次性销毁掉 */
export function destroyWidget(widget: Widget | Container): void {
  if (widget instanceof Container) widget.destroy({ children: true });
  else widget.container.destroy({ children: true });
}
